// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mo-0";
export var animationContainer = "_mo-1";
export var itemPrice = "_mo-a";
export var itemizedContent = "_mo-9";
export var itemizedHeader = "_mo-7";
export var itemizedRow = "_mo-8";
export var itemizedSection = "_mo-6";
export var modalContent = "_mo-2";
export var orderName = "_mo-3";
export var refundOption = "_mo-4";
export var refundOptionsContainer = "_mo-5";
export var shippingLabel = "_mo-b";
export var totalRow = "_mo-c";